
import 'jquery-ui-dist/jquery-ui';

import { toggleChangePassword, submitAccountForm } from './edit_account.js';
import { new_user, heard_from_other } from './new_user.js';
import { WinNow, WinNowMarketing } from './winnow.js';
import { initDeviceSelection } from './devices.js';
import { initDeactivate } from './deactivate.js';
import { RotateTrial } from './rotate_trial.js';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/vendor/jquery-ui-1.12.1.custom/jquery-ui.css';
import 'font-awesome/css/font-awesome.min.css';
import '../../css/site-legacy.less';
import '../../css/rotate.less'; // for Rotate game plan listing
import '../../css/webservices.less';
import '../../css/live.less';


export const App = (function () {

	var ran = false;

	var init = function (page) {

		if (ran) {
			return;
		}

		ran = true;

		if (page === "registration") {
			initRegistration();
		} else if (page === "member") {
			initMember();
		}

		initDefault();

		// Show login status
		$("#login_status").click(function (e) {
			$("#login_actions_wrapper").toggle();
			e.stopPropagation();
		});

		$("body").click(function () {
			$("#login_actions_wrapper").hide();
		});

		// Initialize generic button handling
		$(".button_ok").on("mouseover", function () {
			this.src="/static/img/site/bOK_h.gif";
		});
		$(".button_ok").on("mouseout", function () {
			this.src="/static/img/site/bOK.gif";
		});
		$(".button_ok").on("mousedown", function () {
			this.src="/static/img/site/bOK_.gif";
		});

		// Modules
		if (typeof WinNow !== "undefined"){
			WinNow.init();
			WinNowMarketing.init();
		}
	};

	// Extracted from wrapper.html
	var initDefault = function () {
		if ($("#tabs").tabs !== undefined){
			$("#tabs").tabs();
		}
	};

	var initRegistration = function () {

		$("#bContinue").on("mouseover", function() {
			this.src="/static/img/site/bContinue_h.png";
		});
		$("#bContinue").on("mouseout", function() {
			this.src="/static/img/site/bContinue.png";
		});
		$("#bContinue").on("mousedown", function() {
			this.src="/static/img/site/bContinue_.png";
		});
		$("#bContinue").on("click", function() {
			if ($("span#ws_subscription").length) {
				new_user('/member/subscription');
			} else if ($("#regkind").val() === 'live') {
				new_user('/static/docs/live_reg_complete.html');
			} else {
				new_user('/member/home');
			}
		});

		$(".plan_select_noreg").on("click", function () {
			alert("This page does not handle registration for this product.  Download the SoloStats 123 app, and complete your subscription there.");
			$(this).removeAttr("checked");
		});

		// clear out defaults
		$("#first_name").on("focus", function () {
			if ($(this).val() === "First Name") {
				$(this).val("");
			}
		});
		$("#first_name").on("blur", function () {
			if ($(this).val() === "") {
				$(this).val("First Name");
			}
		});
		$("#last_name").on("focus", function () {
			if ($(this).val() === "Last Name") {
				$(this).val("");
			}
		});
		$("#last_name").on("blur", function () {
			if ($(this).val() === "") {
				$(this).val("Last Name");
			}
		});

		$("#heard_from").on("change", function () {
			heard_from_other($(this).val());
		});

	};

	var initMember = function () {

		RotateTrial.init();

		var gotoMemberTab = function (n){
			$("#tabs3").tabs().tabs("select", n);
		};

		$("#accountFormSubmitButton").on("click", submitAccountForm);
		$("#toggleChangePassword").on("click", toggleChangePassword);

		// see if there is a specified tab to display first
		// (home/) is for legacy reasons
		var matches = window.location.pathname.match(/^\/member(?:\/home\/)?\/(.+)/);

		if (matches.length) {
			var path = matches[1].split("/");
			if (path[0] === "home") {
				path.shift();
			}

			if (path[0] === "rotate123") {
				// this is the current default page
			} else if (path[0] === "webreports") {
				gotoMemberTab(1);
			} else if (path[0] === "video") {
				gotoMemberTab(2);
			} else if (path[0] === "winnow") {
				gotoMemberTab(3);
			}
		}

	};

	var initPromo = () => {
		$("#sub-annual").on("click", function() {
			$("#sub-annual").addClass("hilite");
			$("#sub-monthly").removeClass("hilite");
			$(".paypal.monthly").hide();
			$(".paypal.yearly").show();
		});

		$("#sub-monthly").on("click", function() {
			$("#sub-monthly").addClass("hilite");
			$("#sub-annual").removeClass("hilite");
			$(".paypal.yearly").hide();
			$(".paypal.monthly").show();
		});

	};

	return {
		init: init,
		initDeviceSelection: initDeviceSelection,
		initDeactivate: initDeactivate,
		initPromo: initPromo,
	};

})();
